import "./style.scss";
import "./style-mob.scss";
import { FC } from "react";
import RedLineForTitle from "../RedLineForTitle/RedLineForTitle";

interface ITabs {
  title: string;
  tabs: ITab[];
  currentTab: string;
  setCurrentTab?: (id: string) => void;
}

interface ITab {
  id: string;
  name: string;
}

const Tabs: FC<ITabs> = ({ title, tabs, currentTab, setCurrentTab }) => {
  return (
    <div className="tabs">
      <RedLineForTitle title={title} />
      <div className="tabs-items">
        {tabs.map((tab) => (
          <div
            className={`tabs-item ${currentTab === tab.id ? "active" : ""}`}
            key={tab.id}
            onClick={() => setCurrentTab?.(tab.id)}
          >
            <p>{tab.name}</p>
          </div>
        ))}
      </div>
    </div>
  );
};
export default Tabs;
